// extracted by mini-css-extract-plugin
export default {"Button":"XLcvP8wb","Icon":"qG6mhuK0","ButtonPlaceholder":"yzw1S3Ap","ButtonSkeleton":"AY5PzHSX","IconPlaceholder":"Z0NH0Tjd"};